import { format } from 'date-fns';
import { Society, User } from 'types';

export type AdminEmailActions = 'ADD' | 'EDIT' | 'DELETE';

type CreateAdminEmailProps = {
  t: any;
  language: string;
  action: AdminEmailActions;
  user: User;
  email: string;
  actualSociety: Society;
  mainAdminName?: string;
  updatedAdminName?: string;
};

const getAddAdminEmailData = (props: CreateAdminEmailProps) => {
  const { t, language, email, user, actualSociety } = props;

  return {
    to: [{ email, name: 'Administrador' }],
    subject: t('MailAddSocietyAdminSubject'),
    template: `add-administrator-${language}`,
    templateData: [
      {
        name: 'mainAdminName',
        content: user?.name || '',
      },
      {
        name: 'newAdminEmail',
        content: email,
      },
      {
        name: 'newAdminName',
        content: '',
      },
      {
        name: 'societyName',
        content: actualSociety?.name || '',
      },
      {
        name: 'targetUrl',
        content: `${process.env.REACT_APP_DOMAIN}/#/sociedad/${actualSociety?._id}`,
      },
    ],
  };
};

const getEditAdminEmailData = (props: CreateAdminEmailProps) => {
  const {
    t,
    language,
    email,
    user,
    actualSociety,
    mainAdminName,
    updatedAdminName,
  } = props;

  return {
    to: [{ email, name: mainAdminName }],
    subject: t('EmailAdminModificationSubject'),
    template: `edit-administrator-${language}`,
    templateData: [
      {
        name: 'mainAdminName',
        content: mainAdminName,
      },
      {
        name: 'updatedAdminName',
        content: updatedAdminName,
      },
      {
        name: 'userName',
        content: user.name,
      },
      {
        name: 'societyName',
        content: actualSociety.name,
      },
      {
        name: 'dateTime',
        content: format(new Date(), 'dd/MM/yyyy HH:mm'),
      },
      {
        name: 'targetUrl',
        content: `${process.env.REACT_APP_DOMAIN}/#/perfil-sociedad/administradores/${actualSociety?._id}`,
      },
    ],
  };
};

const getDeleteAdminEmailData = (props: CreateAdminEmailProps) => {
  const {
    t,
    language,
    email,
    user,
    actualSociety,
    mainAdminName,
    updatedAdminName,
  } = props;

  return {
    to: [{ email, name: mainAdminName }],
    subject: t('EmailAdminDeleteSubject'),
    template: `delete-administrator-${language}`,
    templateData: [
      {
        name: 'mainAdminName',
        content: mainAdminName,
      },
      {
        name: 'updatedAdminName',
        content: updatedAdminName,
      },
      {
        name: 'userName',
        content: user.name,
      },
      {
        name: 'societyName',
        content: actualSociety.name,
      },
      {
        name: 'dateTime',
        content: format(new Date(), 'dd/MM/yyyy HH:mm'),
      },
      {
        name: 'targetUrl',
        content: `${process.env.REACT_APP_DOMAIN}/#/perfil-sociedad/administradores/${actualSociety?._id}`,
      },
    ],
  };
};

export const createAdminEmail = (props: CreateAdminEmailProps) => {
  const { user, actualSociety } = props;

  const baseEmailData = {
    user: user['_id'],
    society: actualSociety['_id'],
    date: new Date(),
    status: 'SENT',
  };

  let emailData = {};

  switch (props.action) {
    case 'ADD':
      emailData = getAddAdminEmailData(props);
      break;
    case 'EDIT':
      emailData = getEditAdminEmailData(props);
      break;
    case 'DELETE':
      emailData = getDeleteAdminEmailData(props);
      break;
    default:
      return;
  }

  return {
    ...baseEmailData,
    ...emailData,
  };
};
